import { FieldProps } from 'formik';
import { FC, useEffect, useState } from 'react';
import { Box, Flex, StyledInput } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label } from '../../../typography';
import { SCREEN } from '../../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

type FormGroupProps = Omit<FieldProps, 'meta'> &
  StyledSystemProps & {
    color?: string;
    checked?: boolean;
    disabled?: boolean;
    label?: string;
    pattern?: string;
    readOnly?: boolean;
    step?: string;
    type?: string;
    value?: any;
    onChange?: (option: any) => void;
  };

const TimeFormGroup: FC<FormGroupProps> = props => {
  const [hrsValue, setHrsValue] = useState<number>(Math.floor(Number(props.value) / 60));
  const [minsValue, setMinsValue] = useState<number>(Math.floor(Number(props.value) % 60));

  useEffect(() => {
    const timeValue = Number(hrsValue) * 60 + Number(minsValue);
    props.form.setFieldValue(props.field.name, timeValue);
  }, [hrsValue]);

  useEffect(() => {
    const timeValue = Number(hrsValue) * 60 + Number(minsValue);
    props.form.setFieldValue(props.field.name, timeValue);
  }, [minsValue]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === 'hours') setHrsValue(value);
    if (name === 'minutes') setMinsValue(value);
  };

  const { field, label, step, disabled, readOnly, pattern, checked } = props;

  return (
    <Box {...props} flexDirection="column">
      <Label htmlFor={field.name} pr={isWeb ? undefined : 2}>
        {label}
      </Label>

      <Flex direction="row" justifyContent="flex-start" size="1">
        <Flex direction="column" size="1">
          <StyledInput
            disabled={disabled}
            type="number"
            checked={checked}
            id={field.name}
            px={2}
            {...field}
            onChange={handleChange}
            readOnly={readOnly}
            value={hrsValue}
            pattern={pattern}
            step={step}
            width="100%"
            wrapperWidth="100%"
            color={props.color}
            height={props.height ? props.height.toString() : undefined}
            name="hours"
            mr={4}
          />
          <Label>Hour(s)</Label>
        </Flex>
        <Flex direction="column" size="1">
          <StyledInput
            disabled={disabled}
            type="number"
            checked={checked}
            id={field.name}
            px={2}
            {...field}
            onChange={handleChange}
            readOnly={readOnly}
            value={minsValue}
            pattern={pattern}
            step={step}
            width="100%"
            wrapperWidth="100%"
            color={props.color}
            height={props.height ? props.height.toString() : undefined}
            max={60}
            name="minutes"
            mr={4}
          />
          <Label>Minute(s)</Label>
        </Flex>
      </Flex>

      {/* <ErrorMessage name={field.name}>
        {msg => (
          <Span mt={2} color="error" textAlign="right">
            {msg}
          </Span>
        )}
      </ErrorMessage> */}
    </Box>
  );
};

TimeFormGroup.defaultProps = {
  mb: 3,
  width: '100%',
  type: 'number',
  flex: 1,
  minWidth: isWeb ? '150px' : '100px',
};

export default TimeFormGroup;
